import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=7931b976"
import script from "./FileViewer.vue?vue&type=script&lang=ts"
export * from "./FileViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports